import { useEffect, useState } from "react";
import useSorting from "./useSorting";

type TabConfig = Record<string, any>;

export function useTabState<T extends TabConfig = Record<string, undefined>>(initialConfig?: T) {
  const { sortField, sortDirection, handleSortChange, setSortField, setSortDirection } =
    useSorting();

  const defaultConfig = {
    searchText: undefined,
    status: undefined,
    filterDate: undefined,
    waitApprove: undefined,
  };

  const baseConfig = initialConfig ?? defaultConfig;

  const [fields, setFields] = useState(baseConfig);
  const updateField: any = <K extends keyof T>(key: K, value: T[K]) => {
    setFields((prev) => ({ ...prev, [key]: value }));
  };

  const [page, setPage] = useState(1);

  const reset = () => {
    setSortField(undefined);
    setSortDirection(undefined);
    setFields(defaultConfig);
    setPage(1);
  };
  useEffect(() => {
    setPage(1);
  }, [sortField, sortDirection, fields]);

  const stateHandlers = Object.keys(fields).reduce((acc, key) => {
    const capitalized = key.charAt(0).toUpperCase() + key.slice(1);
    return {
      ...acc,
      [key]: fields[key as keyof typeof fields],
      [`set${capitalized}`]: (val: any) => updateField(key as keyof typeof fields, val),
    };
  }, {} as any);

  return {
    sortField,
    sortDirection,
    handleSortChange,
    setSortField,
    setSortDirection,
    page,
    setPage,
    reset,
    ...stateHandlers,
  };
}
